import styled from 'styled-components'
import LinkRender from '../link/LinkRender';
import SanityImage from '../sanity/SanityImage';

interface P {
  link?: any
}

const SidebarCollectionLink: React.FC<P> = ({
  link,
}: P) => {

  return (
    <Link href={link.href} key={link.key}>
      <Prefix>
        {
          link.image ? 
          <Image alt={link.image.alt || ''}  image={link.image} ratio="1x1" />
          :
          <div>[{link.count || 0}]</div>
        }
      </Prefix>
      <span>{link.title}</span>
    </Link>
  )
}

const Link = styled(LinkRender)`
  display: grid;
  grid-template-columns: 32px 1fr;
  margin-top: 4px;
`

const Image = styled(SanityImage)`
  width: 16px;
`

const Prefix = styled.span`
  display: inline-flex;
  width: 32px;
  color: var(--color-charcoal400);
`

export default SidebarCollectionLink
